import React from "react";
import { RotateCcw } from "lucide-react";

// Shown while the screen isn't landscape. Frames follow the screen, not the
// phone, so with rotation lock on, turning the phone alone isn't enough.
const RotateDeviceOverlay = () => (
  <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-900/95 backdrop-blur-sm p-6">
    <div className="text-center max-w-xs">
      <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5 bg-gradient-to-br from-pink-500/20 to-blue-500/20 border border-pink-500/20">
        <RotateCcw className="w-8 h-8 text-pink-300 animate-pulse" />
      </div>
      <h2 className="text-lg font-semibold mb-2">Turn your phone sideways</h2>
      <p className="text-gray-300 text-sm leading-relaxed">
        Rest it on its side so it can see you, your laptop, and the desk.
      </p>
      <p className="text-gray-400 text-xs leading-relaxed mt-3">
        Screen not rotating? Turn on Auto-rotate. On iPhone, turn off Portrait Orientation Lock in
        Control Center.
      </p>
    </div>
  </div>
);

export default RotateDeviceOverlay;
